import * as React from 'react';
import { IFullPaginationOptions } from './pagination';

export interface IPagingArrowsProps {
    paging: IFullPaginationOptions;
    isLeftArrows: boolean;
    onPageSelect(page: number): void;
}

/// <summary>
/// Renders left or right page arrow content
/// </summary>
/// <returns>Content text</returns>
export function PagingArrows({ paging, isLeftArrows, onPageSelect }: IPagingArrowsProps) {
    if (!paging.totalItems || paging.totalItems === 0) return null;

    const numberOfPages = paging.totalPages;

    if (isLeftArrows) {
        const isDisabled = paging.pageNumber === 1;
        return (
            <li className="adage-search-pagination-arrows adage-search-pagination-arrows-left">
                {isDisabled
                    ?
                    <button disabled={true} className="un-button adage-search-pagination-link-prev">
                        <span dangerouslySetInnerHTML={{ __html: "Previous" }} />
                    </button>
                    :
                    <button className="un-button adage-search-pagination-link-prev" onClick={() => onPageSelect(paging.pageNumber - 1)}>
                        <span dangerouslySetInnerHTML={{ __html: "Previous" }} />
                    </button>
                }
            </li>
        );
    }
    else {
        const isDisabled = paging.pageNumber === numberOfPages;
        return (
            <li className="adage-search-pagination-arrows adage-search-pagination-arrows-right">
                {isDisabled
                    ?
                    <button disabled={true} className="un-button adage-search-pagination-link-next">
                        <span dangerouslySetInnerHTML={{ __html: "Next" }} />
                    </button>
                    :
                    <button className="un-button adage-search-pagination-link-next" onClick={() => onPageSelect(paging.pageNumber + 1)}>
                        <span dangerouslySetInnerHTML={{ __html: "Next" }} />
                    </button>
                }
            </li>
        );
    }
};
